module.exports = global["require"] = require("-!./debug-require.js");